'use client';

import { useSearchParams } from 'next/navigation';

import { Skeleton, SkeletonTextLines } from '../../../core-components/Skeleton';
import { EventTimelineEntry } from '../../shared/EventTimelineEntry';
import { SelectField } from '../../shared/SelectField';
import {
  DashboardTravelItineraryTimelineEntry,
  type DashboardTravelItineraryTimelineEntryProps,
} from '../DashboardTravelItineraryTimelineEntry';

import { DashboardTravelItineraryPlanCard } from './components/Card';

import type { DashboardTravelItineraryPlanCardProps } from './components/Card';
import type React from 'react';

export type DashboardTravelItineraryPlanProps = {
  fallback?: boolean;

  timelineEntries?: DashboardTravelItineraryTimelineEntryProps[];
  card?: DashboardTravelItineraryPlanCardProps;

  travellers?: { id: string; name: string }[];
  ownTravellerId?: string;

  onSwitchTraveller?: (travellerId: string) => void;
};

export const DashboardTravelItineraryPlan = ({
  fallback,
  timelineEntries,
  card,
  travellers,
  ownTravellerId,
  onSwitchTraveller,
}: DashboardTravelItineraryPlanProps) => {
  const t = (str: string) => str; // Replace with actual translation function
  const searchParams = useSearchParams();

  const handleTravellerChange = (
    event: React.ChangeEvent<HTMLSelectElement>,
  ) => {
    const value = event.currentTarget.value;

    onSwitchTraveller?.(value);
  };

  return (
    <div className="flex flex-col gap-6 md:flex-row md:gap-14">
      <div className="flex shrink-0 flex-col gap-10 md:sticky md:top-20 md:w-[296px] md:self-start">
        {fallback ? (
          <div className="flex flex-col gap-2">
            <SkeletonTextLines number={1} />
            <Skeleton className="h-10 w-full" />
          </div>
        ) : travellers ? (
          <SelectField
            label={t('Plan anzeigen für:')}
            className="w-full"
            value={ownTravellerId}
            onChange={handleTravellerChange}
          >
            {travellers?.map(({ id, name }) => (
              <option key={id} value={id}>
                {name}
              </option>
            ))}
          </SelectField>
        ) : null}

        <DashboardTravelItineraryPlanCard
          {...card}
          className="hidden md:flex"
        />
      </div>

      <div className="grow">
        {fallback &&
          Array.from({ length: 3 }).map((_, index) => (
            <EventTimelineEntry key={`fallback-${index}`} fallback />
          ))}

        {!fallback &&
          timelineEntries?.map((props, index) => (
            <DashboardTravelItineraryTimelineEntry key={index} {...props} />
          ))}
      </div>

      <DashboardTravelItineraryPlanCard {...card} className="md:hidden" />
    </div>
  );
};
